import {
  getMobileOperatingSystem,
  isWeb,
} from "../../bridges/BridgeServices";

export const appendHeader = () => {
  if (
    document?.getElementsByClassName("chat-container")?.[0]
  ) {
    document
      .getElementsByClassName("chat-container")?.[0]
      ?.classList?.add("chat-bottom");

    const parent = document?.getElementsByClassName(
      "chat-head"
    )[0];
    const newElement = document?.createElement("div");
    newElement.className = "support-header";

    const headerContainerChild = document?.createElement(
      "div"
    );

    const headerChild = document?.createElement("div");
    headerChild.innerHTML = "Support";
    headerChild.className = "header-title";

    headerContainerChild.appendChild(headerChild);

    // const svgChild = document?.createElement("div");
    // svgChild.innerHTML = flash;
    // svgChild.className = "flash-icon";

    // newElement.appendChild(svgChild);
    newElement.appendChild(headerContainerChild);

    parent.insertBefore(newElement, parent.firstChild);
  }
};

export const openBot = () => {
  document.getElementsByClassName(
    "support-close-icon"
  )[0].style.display = "block";
  document
    .getElementsByClassName("support-close-icon")[0]
    .classList.remove("hide");
  document.getElementById("mobile-chat-container")?.click();
  appendHeader();
};

export const getPlatformForBot = () => {
  if (isWeb()) {
    return "sb_web";
  }
  const OS = getMobileOperatingSystem();
  if (OS === "ANDROID") {
    return "sb_app_android";
  }
  if (OS === "IOS") {
    return "sb_app_iOS";
  }
};
